export default __webpack_public_path__ + "static/media/8_instituicoes-publicas.76d28a5a.webp";